module.exports = __webpack_public_path__ + "img/draw-bg.0b68987f.svg";